import { MatchingType, UserRight } from '@biteinc/enums';
import { AbstractModelSchema } from './abstract_model_schema.js';
export const quizSchema = {
    displayName: 'quiz',
    type: 'object',
    fields: {
        ...AbstractModelSchema.fields,
        name: {
            type: 'keyString',
            required: true,
            writeRight: UserRight.BiteSupport,
        },
        resultQuantity: {
            displayName: 'Quantity of Results',
            type: 'int',
            required: true,
            min: 0,
            max: 9,
            writeRight: UserRight.BiteSupport,
        },
        matchingAlgorithmType: {
            displayName: 'Matching Algorithm',
            type: 'stringEnum',
            enum: MatchingType,
            required: true,
            writeRight: UserRight.BiteSupport,
        },
        preselectMatchingMods: {
            displayName: 'Preselect Matching Mods',
            tooltip: {
                text: 'If enabled, the system will preselect the mods that map to the badges in the users selection.',
            },
            type: 'bool',
            writeRight: UserRight.BiteSupport,
        },
        stepIds: {
            type: 'array',
            elementType: 'mongoId',
            displayName: 'Quiz Steps',
            placeholder: 'Select Quiz Steps',
            ui: 'table',
            writeRight: UserRight.BiteSupport,
        },
        orgId: {
            type: 'mongoId',
            isHidden: true,
            isReadOnly: true,
        },
        siteId: {
            type: 'mongoId',
            isHidden: true,
            isReadOnly: true,
        },
        locationId: {
            type: 'mongoId',
            required: true,
            isHidden: true,
            isReadOnly: true,
        },
    },
};
//# sourceMappingURL=quiz_schema.js.map